module.exports = {
      id: "chf-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#chf-usage",
      toString: function () {
        return this.url;
      }
    }